import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public activeAccount!: any;
  public authenticated$ = new Subject<void>();

  private readonly _destroying$ = new Subject<void>();

  constructor(
    private broadcastService: MsalBroadcastService,
    private msalService: MsalService
  ) {
    this.onProgress();
  }

  onProgress = () => {
    this.broadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
  };

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount) {
      const accounts = this.msalService.instance.getAllAccounts();
      if (accounts.length === 0) return;

      const account = accounts[0];
      this.msalService.instance.setActiveAccount(account);
      this.activeAccount = account;

      this.authenticated$.next();
    }
  }

  /**
   * @def used to get user roles
   */
  public getUserRoles(): any {
    if (!this.activeAccount) return null;

    return this.activeAccount.idTokenClaims.roles;
  }
}
